<!-- Start New Trial -->
<p-dialog [(visible)]="visible" (onHide)="closePopup(false)" [resizable]="false" appendTo="body" [modal]="true" [breakpoints]="{'767px': '100vw'}"
  [style]="{width: '1050px'}" styleClass="no-header-modal overflow-visible">

  <ng-template pTemplate="header" styleClass="hidden"></ng-template>
  <ng-template pTemplate="content" styleClass="p-0">

    <!-- Header -->
    <div class="p-3 flex align-items-center justify-content-between border-bottom-1 border-300">

      <h2 class="mb-0 text-sm">{{'CLIENT_TRIAL.START_NEW_TRIAL' | translate}}</h2>
      <div class="text-xl text-600" *ngIf="showCreateTrialButton">
        <p-button icon="fa fa-plus" styleClass="p-button-text" label="{{'CLIENT_TRIAL.BTN_CREATE_TRIAL' | translate}}" (click)="createTrialConfirm()"></p-button>
      </div>
      <div class="fa fa-times text-xl text-600 cursor-pointer" (click)="closePopup(false)"></div>
    </div>
    <!-- Header -->

    <!-- Content -->
    <div class="surface-100 text-sm">
        <calendar [onlyTrialAllowed]="true" (emitEvents)="getEventData($event)"></calendar>
    </div>
    <!-- Content -->
    
    <!-- Footer -->
  </ng-template>

</p-dialog>


<p-confirmDialog [header]="'Confirmation'" [icon]="'fa fa-exclamation-triangle'" [rejectButtonStyleClass]="'p-button-text'"></p-confirmDialog>


<app-errors *ngIf="showErrorPopup$ | async as showPopup" [error]="error" [visible]="showPopup"
[errorData]="errorMessages" (hideErrorPopup)="HideErrorPopup($event)">
</app-errors>

<!-- Start New Trial -->